import NetworkingOperations from "../index";

const PaymentData = (data) => {
	const url = process.env.REACT_APP_PAYMENT_GET_PAYMENT_DATA;

	return NetworkingOperations.post({ url, data }).then((res) => res);
};

export default PaymentData;
